import React, { useEffect, useState } from "react";
import axiosInstance from "./api/axiosInstance";

export const UPI_ID_PATTERN = /^[a-z0-9.\-_]{2,256}@[a-z][a-z0-9.-]{1,63}$/i;

/** "" when valid or blank, otherwise a message for the form. */
export function upiIdError(value) {
  const v = String(value || "").trim();
  if (!v || UPI_ID_PATTERN.test(v)) return "";
  return "UPI ID must look like name@bank.";
}

/**
 * UPI ID + "Receives payments for" (issuer company) fields shared by Add / Edit company account.
 * These drive the Pay option clients see in the customer portal.
 */
function CompanyAccountPaymentFields({ form, onChange }) {
  const [issuers, setIssuers] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axiosInstance
      .get("/fico/issuer-companies", { params: { status: "Active" } })
      .then((res) => {
        const rows = Array.isArray(res.data) ? res.data : res.data?.data || [];
        if (!cancelled) setIssuers(rows);
      })
      .catch(() => {
        if (!cancelled) setIssuers([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <div className="form-group">
        <label>UPI ID</label>
        <input
          name="UPI_Id"
          value={form.UPI_Id || ""}
          onChange={onChange}
          placeholder="e.g. company@okhdfcbank"
          autoComplete="off"
          inputMode="email"
        />
      </div>
      <div className="form-group">
        <label>Receives payments for</label>
        <select name="Issuer_Company_Id" value={form.Issuer_Company_Id || ""} onChange={onChange}>
          <option value="">All issuing companies</option>
          {issuers.map((c) => (
            <option key={c.Issuer_Company_Id} value={String(c.Issuer_Company_Id)}>
              {c.Display_Name || c.Company_Name}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}

export default CompanyAccountPaymentFields;
